
import React from 'react';
import { Alert, CopyToClipboard } from '../components/atoms';
import { Device } from '../interfaces';
import { DevicesService } from '../services';

export const getDeviceIPModal = (device: Pick<Device, 'id'>) => (evt?: any) => {
  DevicesService.getDeviceVPNIp(device.id).then(async (res) => {
    new Alert(<CopyToClipboard children={res} />).promise;
  });

  evt?.stopPropagation();
  evt?.preventDefault();
};
